import {Dropdown} from 'antd'
import {PaperClipOutlined} from '@ant-design/icons'
import {DraftIconButton} from './DraftButton.jsx'
import {useAiContext} from './AiContext.mjs'
import {useAttach} from './useAttach.jsx'

export const ButtonAttach = props => {
    const ai = useAiContext()
    const {isAttachDisabled, pickDir, pickFile} = useAttach()

    if (1 < ai.maxFileCount) {
        const items = [
            {
                key: 'file',

                label: (
                    <div onClick={pickFile}>
                        选择文件...
                    </div>
                ),
            },

            {
                key: 'dir',

                label: (
                    <div onClick={pickDir}>
                        选择文件夹...
                    </div>
                ),
            },
        ]

        return (
            <Dropdown
                disabled={isAttachDisabled}
                menu={{items}}
                {...props}
            >
                <DraftIconButton>
                    <PaperClipOutlined />
                </DraftIconButton>
            </Dropdown>
        )
    }
    else {
        return (
            <DraftIconButton
                title="选择文件..."
                onClick={pickFile}
                {...props}
            >
                <PaperClipOutlined />
            </DraftIconButton>
        )
    }
}
